document.addEventListener('DOMContentLoaded', function () {
  var descriptionWrappers = document.querySelectorAll('[data-collection-description]');

  if (!descriptionWrappers.length) return;

  descriptionWrappers.forEach(function (descriptionWrapper) {
    var descriptionContent = descriptionWrapper.querySelector('[data-description-content]');
    var descriptionToggle = descriptionWrapper.querySelector('[data-description-toggle]');
    var descriptionToggleText = descriptionWrapper.querySelector('[data-description-toggle-text]');

    if (!descriptionContent || !descriptionToggle || !descriptionToggleText) return;

    var collapsedLabel = descriptionToggle.getAttribute('data-label-collapsed') || 'Read more';
    var expandedLabel = descriptionToggle.getAttribute('data-label-expanded') || 'Read less';
    var minLines = parseInt(descriptionWrapper.getAttribute('data-description-lines'), 10) || 5;
    var resizeTimer;

    function getLineHeight(element) {
      var computedStyles = window.getComputedStyle(element);
      var lineHeight = parseFloat(computedStyles.lineHeight);

      if (!isNaN(lineHeight)) return lineHeight;

      var fontSize = parseFloat(computedStyles.fontSize) || 16;
      return fontSize * 1.6;
    }

    function syncDescription(expanded) {
      var lineHeight = getLineHeight(descriptionContent);
      var collapsedHeight = Math.ceil(lineHeight * minLines);

      descriptionContent.style.maxHeight = 'none';
      descriptionContent.classList.remove('is-collapsed');

      var fullHeight = descriptionContent.scrollHeight;
      var needsToggle = fullHeight > collapsedHeight + 4;

      if (!needsToggle) {
        descriptionToggle.hidden = true;
        descriptionToggle.setAttribute('aria-expanded', 'false');
        descriptionToggleText.textContent = collapsedLabel;
        descriptionContent.style.maxHeight = 'none';
        return;
      }

      descriptionToggle.hidden = false;
      descriptionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      descriptionToggleText.textContent = expanded ? expandedLabel : collapsedLabel;

      if (expanded) {
        descriptionContent.style.maxHeight = fullHeight + 'px';
      } else {
        descriptionContent.style.maxHeight = collapsedHeight + 'px';
        descriptionContent.classList.add('is-collapsed');
      }
    }

    syncDescription(false);

    descriptionToggle.addEventListener('click', function () {
      var expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
      syncDescription(!expanded);
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        var expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
        syncDescription(expanded);
      }, 120);
    });
  });
});
